import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520b2a4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "dialog",
  class: "error"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "items" }
const _hoisted_4 = { class: "notice" }
const _hoisted_5 = { class: "index" }
const _hoisted_6 = { class: "message" }
const _hoisted_7 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ButtonIcon, {
          class: "icon",
          icon: "error"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.errors.length) + " 件のエラーが発生しました。 ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.index,
              class: "item"
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(error.index + 1) + " 件目", 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(error.message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
        }, "閉じる")
      ])
    ], 512)
  ]))
}